export function getDeclarationConsents(bookings, products) {

    const byLink = new Map();

    (bookings || []).forEach((booking) => {
        const product = (products || []).find(p => p.id === booking.productId);
        const link = product?.declarationConsentLink;

        if(!link) {
            return;
        }

        const entry = byLink.get(link) || {link, productNames: []};

        if(product?.name && !entry.productNames.includes(product.name)) {
            entry.productNames.push(product.name);
        }

        byLink.set(link, entry);
    });

    return [...byLink.values()];
}
